import styled from '@emotion/styled';
import { css } from 'twin.macro';

export const locationMarkerStyles = css`
    position: absolute;
    top: 10px;
    right: 60px;
    background-color: white;
    border-radius: 50%;
    padding: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const MapStyledDiv = styled.div`
    width: 100%;
    height: 400px;
    position: relative;
    margin: 20px 0;
`;

export const OpenInGoogleMapDiv = styled.div`
    position: absolute;
    bottom: 10px;
    left: 10px;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 5px;
    cursor: pointer;
`;
